import styled from '@emotion/styled';
import { Icon } from '@pairy/pds-react';
import * as Accordion from '@radix-ui/react-accordion';

import { slideDown, slideUp } from '@/styles/keyframes/slide';

export const AccordionRoot = styled(Accordion.Root)`
  width: 100%;
`;

export const AccordionItem = styled(Accordion.Item)`
  /*
   * 콘텐츠 영역의 각진 배경이 카드의 둥근 모서리를 덮어 하단 보더가 잘려 보인다.
   * 자식을 라운드 모양으로 잘라내 모서리를 살린다. 펼침 애니메이션도 height 기반이라
   * 클리핑이 필요하고, 콘텐츠 안에는 바깥으로 넘쳐야 하는 요소가 없다(토스트는 포털).
   */
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const AccordionTrigger = styled(Accordion.Trigger)`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 16px;
  gap: 8px;
  &[data-state='open'] {
    border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
  }

  &.nothing {
    border-bottom: 0;
  }
`;

export const ChevronIcon = styled(Icon)`
  [data-state='closed'] & {
    transform: rotate(180deg);
  }

  transition: transform 0.15s ease-in-out;
`;

export const AccordionContent = styled(Accordion.Content)`
  &[data-state='closed'] {
    animation: ${slideUp('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
  }
  &[data-state='open'] {
    display: flex;
    flex-direction: column;
    animation: ${slideDown('var(--radix-collapsible-content-height)')} 0.15s
      ease-in-out;
  }

  background: ${({ theme }) => theme.colors.zinc_50};
`;
